<template>
  <sider-menu-layout :on-navigate="handleNavigate">
    <template #content>
      <div style="padding: 12px; height: 100%">
        <router-view v-slot="{ Component }">
          <keep-alive :max="10">
            <content-fade-view
              v-if="route.meta.keepAlive"
              :key="route.name"
              :page="Component"
              :content-style="{ padding: 0 }"
            />
          </keep-alive>
          <content-fade-view
            v-if="!route.meta.keepAlive"
            :key="route.name"
            :page="Component"
            :content-style="{ padding: 0 }"
          />
        </router-view>
      </div>
    </template>
  </sider-menu-layout>
</template>
<script setup lang="ts">
import ContentFadeView from '@/components/layout/content-fade-view/index.vue';
import SiderMenuLayout from '@/components/layout/sider-menu-layout/index.vue';
import { PermissionPageKey } from '@/types/permission';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

/**
 * @description 自定义导航回调，保留搜索查询参数
 */
function handleNavigate(key: string) {
  const keepQuery = key === PermissionPageKey.IssueList || key === PermissionPageKey.IssueDashboard;
  router.push({ name: key, query: keepQuery ? route.query : undefined });
}
</script>
